import {
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Divider,
  SxProps,
  Theme,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { RetailerNetworkTobaccoManufacturerOfferPerformanceFragment } from '@occc/graphql';
import { CircularProgress } from '@occc-app/design-system';

import { RetailerNetworkTobaccoOffersTable } from './retailer-network-tobacco-offers-table.component';

export type RetailerNetworkTobaccoOffersSectionProps = {
  title: string;
  multiUnitOffers: RetailerNetworkTobaccoManufacturerOfferPerformanceFragment[];
  loyaltyOffers: RetailerNetworkTobaccoManufacturerOfferPerformanceFragment[];
  loading?: boolean;
  setExpanded: (expanded: boolean) => void;
  defaultExpanded?: boolean;
};

const HORIZONTAL_PADDING = 3;

const dividerSx: SxProps<Theme> = {
  mx: -HORIZONTAL_PADDING,
};

export const RetailerNetworkTobaccoOffersSection = ({
  title,
  multiUnitOffers,
  loyaltyOffers,
  loading,
  setExpanded,
  defaultExpanded,
}: RetailerNetworkTobaccoOffersSectionProps) => {
  return (
    <Accordion
      elevation={2}
      defaultExpanded={defaultExpanded}
      onChange={(_, expanded) => setExpanded(expanded)}
      disableGutters
      sx={{
        borderRadius: 1,
        '&::before': {
          height: 0,
        },
        '&::after': {
          height: 0,
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          py: 1.5,
          px: HORIZONTAL_PADDING,
        }}
      >
        <Typography variant='body1' fontWeight={500}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          px: HORIZONTAL_PADDING,
          pt: 0,
        }}
      >
        <Divider sx={dividerSx} />

        <Stack>
          {loading ? (
            <Box p={4} display='flex' justifyContent='center'>
              <CircularProgress />
            </Box>
          ) : (
            <>
              <RetailerNetworkTobaccoOffersTable data={multiUnitOffers} title='Multi Unit Offers' />
              <Divider
                sx={{
                  ...dividerSx,
                  mt: 2,
                }}
              />
              <RetailerNetworkTobaccoOffersTable data={loyaltyOffers} title='Loyalty Offers' />
            </>
          )}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};
